import routeName from '../constant';

const routes = [{
    path: 'invest-dividend-pay-way',
    name: routeName.INVEST_DIVIDEND_PAY_WAY,
    component: () => import('@/views/aplCatl640and631/AG/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '投資配息/提解給付方式變更', leaveAlert: true, code: 'AG', unableBack: true },
}];

export default routes;
